import { useSnackbar } from "notistack";

export default function useSnackbarPromise(): (
  promise: Promise<any>,
  options: {
    successMessage: string;
    errorMessage: string;
  }
) => Promise<any> {
  const { enqueueSnackbar } = useSnackbar();

  return function (promise, options) {
    return promise
      .then((r) => {
        enqueueSnackbar(options.successMessage, { variant: "success" });
        return r;
      })
      .catch((e) => {
        enqueueSnackbar(options.errorMessage, { variant: "error" });
        throw e;
      });
  };
}
